import { parseISO } from 'date-fns';
export const sortSheduleItems = (id, desc) => (fisrtItem, secondItem) => {
    let valueA;
    let valueB;
    switch (id) {
        case 'position':
            valueA = fisrtItem.position;
            valueB = secondItem.position;
            break;
        case 'date':
            valueA = parseISO(fisrtItem.date).getTime();
            valueB = parseISO(secondItem.date).getTime();
            break;
        default:
            return 0;
    }
    if (valueA < valueB) {
        return desc ? 1 : -1;
    }
    if (valueA > valueB) {
        return desc ? -1 : 1;
    }
    return 0;
};
